import AppContentSection from '../../app-ui/AppContentSection';
import { useAppUi } from '../../app-ui/AppUiScope';
import React from 'react';
import { AlbumCard } from './AlbumCard';
import { Link } from 'react-router-dom';
import Chevron from './Chevron';
import ContentShelf from '../responsive/ContentShelf';
import { useWebLocale } from '../../contexts/WebLocaleContext';

export function DiscoveryHeading({ title }) {
  const { locale, setLocale, t } = useWebLocale();
  return (
    <div className="pp-section-heading">
      <h1>{title}</h1>
      <select
        className="pp-action"
        aria-label={t('language')}
        value={locale}
        onChange={(event) => setLocale(event.target.value)}
      >
        <option value="ko">한국어</option>
        <option value="en">English</option>
      </select>
    </div>
  );
}
export { albumPath } from './albumPath';
export function ContentState({ query, children }) {
  const { t } = useWebLocale();
  if (query.isPending) return <p role="status">{t('loading')}…</p>;
  if (query.isError && !query.data)
    return (
      <div role="alert">
        <p>{t('error')}</p>
        <button className="pp-action" onClick={() => query.refetch()}>
          {t('retry')}
        </button>
      </div>
    );
  return children;
}
export function DiscoverySection({ title, to, children, inlineMore = false }) {
  const { t } = useWebLocale();
  const appUi = useAppUi();
  if (appUi)
    return (
      <AppContentSection title={title} to={to} inlineMore={inlineMore}>
        {children}
      </AppContentSection>
    );
  return (
    <section className="pp-discovery-section">
      <div className="pp-section-heading">
        <h2>
          {inlineMore && to ? (
            <Link className="pp-section-title-link" to={to} aria-label={`${title} · ${t('more')}`}>
              {title}
              <Chevron className="pp-heading-chevron" />
            </Link>
          ) : (
            title
          )}
        </h2>
        {to && !inlineMore && (
          <Link to={to} aria-label={`${title} · ${t('more')}`}>
            {t('more')}
          </Link>
        )}
      </div>
      {children}
    </section>
  );
}
export function AlbumCollection({ items = [], rail = false, label }) {
  const { t } = useWebLocale();
  if (!items.length) return <p className="pp-secondary">{t('empty')}</p>;
  const Wrapper = rail ? ContentShelf : 'div';
  return (
    <Wrapper
      label={rail ? label || t('albums') : undefined}
      className={rail ? '' : 'pp-album-grid'}
    >
      {items.map((item, index) => (
        <AlbumCard item={item} key={`${item.id || item.albumId || item.sourceId}-${index}`} />
      ))}
    </Wrapper>
  );
}
